import type { JSX } from 'react';
import { Card, Notice } from '@/components/primitives';

/**
 * A build that cannot authenticate says so, full-screen, instead of rendering
 * the app without a login. The message names the variable at fault.
 */
export function ConfigErrorScreen({ message }: { readonly message: string }): JSX.Element {
  return (
    <div style={{ padding: 32 }}>
      <Card style={{ maxWidth: 680, margin: '60px auto' }}>
        <h3>This build is misconfigured</h3>
        <Notice tone="bad" style={{ marginTop: 12 }}>
          <pre style={{ whiteSpace: 'pre-wrap', margin: 0, font: 'inherit' }}>{message}</pre>
        </Notice>
        <p className="muted" style={{ marginTop: 12 }}>
          Authentication variables are set per environment at build time. See the README section
          &ldquo;Authentication&rdquo;.
        </p>
      </Card>
    </div>
  );
}
